module.exports = __webpack_public_path__ + "img/error.d1aff05e.png";